package com.tovtalk.ui.platform

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

actual fun getBottomSafeAreaInsetDp(): Dp = 0.dp
